import {
  VuexModule,
  Module,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import {
  KulionerListRequest,
  KulionerConfirmOrderRequest
} from "@/data/payload/api/KulionerApiRequest";
import { container } from "tsyringe";
import { KulionerPrensenter } from "../presenters/KulionerPresenter";
import { KulionerComponent } from "@/app/infrastructures/dependencies/modules/KulionerComponent";
import { DownloadReportRequest } from "@/domain/entities/Kulioner";
import { ListSttPresenter } from "../presenters/ListSttPresenter";
import { BookingPresenter } from '../presenters/BookingPresenter';
import { BookingController } from './BookingController';
import { AccountController } from './AccountController';
import { PrintDataEntitas } from '@/domain/entities/Booking';
KulionerComponent.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "kulioner"
})
class KulionerStore extends VuexModule {
  @Action
  async getKulionerList(params: KulionerListRequest) {
    const presenter = container.resolve(KulionerPrensenter);
    return presenter.getList(params).then(res => {
      return res;
    });
  }

  @Action
  async getKulionerDetail(id: number) {
    const presenter = container.resolve(KulionerPrensenter);
    return presenter.get(id);
  }

  @Action
  async getDownloadReports(params: DownloadReportRequest) {
    const presenter = container.resolve(KulionerPrensenter);
    return presenter.getDownloadReports(params);
  }

  @Action
  public updateKulioner(payload: KulionerConfirmOrderRequest) {
    const presenter = container.resolve(KulionerPrensenter);
    return presenter.updateKulioner(payload);
  }

  @Action
  public getSttDetail(params: { sttNumber: string }) {
    const presenter = container.resolve(ListSttPresenter);
    return presenter.getSttList(1, 50, 0, "", "", "", "", params.sttNumber, "");
  }

  @Action
  async updateToggle(id: number) {
    const presenter = container.resolve(KulionerPrensenter);
    return presenter.updateToggle(id);
  }

  @Action
  async getListSummaryStatus(params: KulionerListRequest) {
    const presenter = container.resolve(KulionerPrensenter);
    return presenter.getListSummaryStatus(params).then(res => {
      return res;
    });
  }

  @Action
  async getShipmentIdList(shipmentId: string) {
    const presenter = container.resolve(BookingPresenter);
    return presenter.getShipmentIdList(shipmentId, 100, 1);
  }

  @Action
  async getListStt(
    params: {
      page: number;
      limit: number;
      destinationCityId: number;
      userType: string;
      bookedBy: string;
      fromDate: string;
      endDate: string;
      sttNumber: string;
      bookedType: string;
    }
  ): Promise<PrintDataEntitas[]> {
    const presenter = container.resolve(ListSttPresenter)
    return new Promise((resolve, reject) => {
      presenter.getSttList(
        params.page,
        params.limit,
        params.destinationCityId,
        params.userType,
        params.bookedBy,
        params.fromDate,
        params.endDate,
        params.sttNumber,
        params.bookedType
      ).then(async (res) => {
        const list: Array<any> = [];
        for (const [index, item] of res.data.entries()) {
          await BookingController.generatePrintThermal({
            stt: item.sttId,
            accountType:
              AccountController.accountData.account_type === "partner"
                ? AccountController.accountData.account_type_detail.type
                : AccountController.accountData.account_type
          })
            .then(data => {
              list.push(data);
              if (index === res.data.length - 1) {
                resolve(list);
              }
            })
            .catch((error: any) => {
              reject(error);
            });
        }
      }).catch((error) => {
        reject(error);
      })
    })
  }
}

export const KulionerController = getModule(KulionerStore);
